import {useDebugValue} from 'react';

import {noop} from '../../../utils';

import {useEvents} from './';

const defaultEvents = {
    onClick: noop
};

function useDestinationSummaryEvents(props) {
    const {
        destinationSummaryEvents: propsEvents
    } = props;

    const {
        events
    } = useEvents(defaultEvents, propsEvents);

    const result = {
        events
    };

    useDebugValue(result);

    return result;
}

export {useDestinationSummaryEvents};
